import './masthead.css';

import './img/lavakidneys_1680x400.jpg';
import './img/lavakidneys_1680x400@2x.jpg';
import './img/lavakidneys_530x400.jpg';
import './img/lavakidneys_530x400@2x.jpg';
import './img/lavakidneys_800x400.jpg';
import './img/lavakidneys_800x400@2x.jpg';

import './img/space_1680x400.jpg';
import './img/space_1680x400@2x.jpg';
import './img/space_530x400.jpg';
import './img/space_530x400@2x.jpg';
import './img/space_800x400.jpg';
import './img/space_800x400@2x.jpg';

import '../../search/trending-searches/trending-searches';
